/**
 * Shared quick reasons for property deletion flows. Every substantive reason
 * already satisfies the minimum deletion-reason length so picking one (other
 * than "Other") immediately unlocks the delete action; "Other" always
 * requires a typed explanation.
 */

/** Deletion reasons must be strictly more than 10 characters. */
export const DELETION_REASON_MIN_LENGTH = 11;

export const OTHER_REASON_OPTION = "Other (specify below)";

export const PROPERTY_DELETION_QUICK_REASONS: string[] = [
  "Property no longer available / Sold",
  "Duplicate property post",
  "Incorrect details posted by mistake",
  "Posted in the wrong category or location",
  "Taking a break from listing",
  "Rented out through another channel",
  OTHER_REASON_OPTION,
];

export const isDeletionReasonValid = (
  reason: string | null | undefined,
): boolean => (reason ?? "").trim().length >= DELETION_REASON_MIN_LENGTH;

export const deletionReasonHint = (
  reason: string | null | undefined,
): string => {
  const length = (reason ?? "").trim().length;
  if (length === 0) return "A reason is required to delete this property.";
  if (length < DELETION_REASON_MIN_LENGTH) {
    return `Reason must be more than 10 characters (currently ${length}).`;
  }
  return "";
};
